import { useTabUrl } from '@common/hooks/useTabUrl';
import { Layout } from '@common/layouts';
import { NavigationTabsOption } from '@common/types/link';
import { Box } from '@radix-ui/themes';
import { useTranslation } from 'react-i18next';
import { ClipSearchView, CollectionSearchView } from '../components';

export const AdvancedSearchPage = () => {
    const { t } = useTranslation('advancedSearch');

    const searchOptions: NavigationTabsOption<'collection' | 'clip'>[] = [
        {
            label: t('table.modes.collection'),
            value: 'collection',
            queryKey: 'type',
        },
        { label: t('table.modes.clip'), value: 'clip', queryKey: 'type' },
    ];

    const { currentTab } = useTabUrl(searchOptions, 'collection', () => {});

    return (
        <Layout.Content direction={'row'} overflow={'hidden'}>
            <Box height={'100%'} p='4'>
                {currentTab === 'collection' && (
                    <CollectionSearchView
                        tabOptions={searchOptions}
                        key='collection'
                        // prefix={currentTab}
                    />
                )}
                {currentTab === 'clip' && (
                    <ClipSearchView
                        tabOptions={searchOptions}
                        key='clip'
                        // prefix={currentTab}
                    />
                )}
            </Box>
        </Layout.Content>
    );
};
